import { chat } from "@/lib/http";

export interface CallResponse {
  call: {
    id: string;
    conversation_id: string;
    caller_id: string;
    is_host?: boolean;
    type: "audio" | "video";
    status: string;
    started_at: string;
    ended_at: string | null;
  };
  token: string;
}

export function joinCall(callId: string) {
  return chat<CallResponse>(`/v1/chat/calls/${callId}/join`, {
    method: "POST",
  });
}

export function startCall(conversationId: string, type: "audio" | "video") {
  return chat<CallResponse>("/v1/chat/calls", {
    method: "POST",
    body: JSON.stringify({ conversation_id: conversationId, type }),
  });
}

export function acceptCall(callId: string) {
  return joinCall(callId);
}

export function declineCall(callId: string) {
  return chat<void>(`/v1/chat/calls/${callId}/decline`, {
    method: "POST",
  });
}

export function endCall(callId: string) {
  return chat<void>(`/v1/chat/calls/${callId}/end`, {
    method: "POST",
  });
}

export function leaveCall(callId: string) {
  return chat<void>(`/v1/chat/calls/${callId}/leave`, {
    method: "POST",
  });
}
